import { useCallback, useEffect, useRef } from "react";

export const WakeLocked = () => {
  const wakeLockSentinel = useRef<WakeLockSentinel | null>(null);
  const wakeLockPending = useRef(false);

  const requestWakeLock = useCallback(async () => {
    // A wake lock request is already pending
    if (wakeLockPending.current) {
      console.log("Wake lock request already pending");
      return;
    }

    try {
      // Already have a wake lock
      if (wakeLockSentinel.current?.released === false) {
        console.log("Wake lock already acquired");
        return;
      }

      // Document is not visible
      if (document.visibilityState !== "visible") {
        console.log("Document not visible, not requesting wake lock");
        return;
      }

      // Wake Lock API not supported
      if (!("wakeLock" in navigator)) {
        console.log("Wake Lock API not supported");
        return;
      }

      console.log("Requesting wake lock");

      wakeLockPending.current = true;
      wakeLockSentinel.current = await navigator.wakeLock.request("screen");
    } catch (error) {
      console.error("Failed to acquire wake lock:", error);
    } finally {
      wakeLockPending.current = false;
    }
  }, []);

  useEffect(() => {
    document.addEventListener("click", requestWakeLock);
    document.addEventListener("visibilitychange", requestWakeLock);

    return () => {
      document.removeEventListener("click", requestWakeLock);
      document.removeEventListener("visibilitychange", requestWakeLock);
    };
  }, [requestWakeLock]);

  return null;
};
